export default __webpack_public_path__ + "static/media/SAmaps.3256b16a.png";